import { render, staticRenderFns } from "./FundingSettingsSection.vue?vue&type=template&id=4b64ec4f&scoped=true"
import script from "./FundingSettingsSection.vue?vue&type=script&lang=js"
export * from "./FundingSettingsSection.vue?vue&type=script&lang=js"
import style0 from "./FundingSettingsSection.vue?vue&type=style&index=0&id=4b64ec4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64ec4f",
  null
  
)

export default component.exports